export const CATEGORY_MIN_PATENT_COUNT = 30;
export var ViewType;
(function (ViewType) {
    /** 表格视图 */
    ViewType["TABLE"] = "table";
    /** 图文视图 */
    ViewType["STANDARD"] = "standard";
    /** 全文附图 */
    ViewType["FULL_IMAGE"] = "fullImage";
    /** 缩略视图 */
    ViewType["THUMB"] = "thumbnail";
    /** 表格视图 lite 版 */
    ViewType["FAST_TABLE"] = "fastTable";
    /** 词云视图 */
    ViewType["WORD_CLOUD"] = "wordCloud";
    /** 研发视图 */
    ViewType["CATEGORY"] = "category";
})(ViewType || (ViewType = {}));
/**
用户权限接口中返回的视图信息为
    patentFolderPage
    patentImagePage
    patentFullimgPage
    patentThumbPage

patents等后端接口接收的视图信息为
    'tablelist'
    'standardlist'
    'pdfimage'
    'thumbnail'
    'fasttablelist'

前端使用的视图信息为
    TABLE = 'table',
    STANDARD = 'standard',
    FULL_IMAGE = 'fullImage',
    THUMB = 'thumbnail',
    FAST_TABLE = 'fastTable',
    WORD_CLOUD = 'wordCloud',
    CATEGORY = 'category',
 */ 
